"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToolbarGoToComponent = void 0;
const React = __importStar(require("react"));
const antd_1 = require("antd");
const CurrentProjectProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/provider/CurrentProjectProvider");
const lodash_1 = __importDefault(require("lodash"));
const react_router_dom_1 = require("react-router-dom");
const AppRouting_1 = require("src/hello_assets/src/components/system/AppRouting");
const icons_1 = require("@ant-design/icons");
const react_1 = require("react");
const goToMenu = (projectApiKey) => {
    const items = (0, react_1.useMemo)(() => {
        return lodash_1.default.compact([
            { key: "dashboard", label: React.createElement(react_router_dom_1.Link, { to: AppRouting_1.AppPathGenerator.Project.home(projectApiKey) }, "Dashboard") },
            { key: "activeUsers", label: React.createElement(react_router_dom_1.Link, { to: AppRouting_1.AppPathGenerator.Project.activeUsers(projectApiKey) }, "Active Users") },
            { key: "newUsers", label: React.createElement(react_router_dom_1.Link, { to: AppRouting_1.AppPathGenerator.Project.newUsers(projectApiKey) }, "New Users") },
            { key: "retention", label: React.createElement(react_router_dom_1.Link, { to: AppRouting_1.AppPathGenerator.Project.retention(projectApiKey) }, "Retention") },
            { key: "lifecycle", label: React.createElement(react_router_dom_1.Link, { to: AppRouting_1.AppPathGenerator.Project.lifecycle(projectApiKey) }, "Lifecycle") },
            { key: "stickiness", label: React.createElement(react_router_dom_1.Link, { to: AppRouting_1.AppPathGenerator.Project.stickiness(projectApiKey) }, "Stickiness") },
            { key: "events", label: React.createElement(react_router_dom_1.Link, { to: AppRouting_1.AppPathGenerator.Project.events(projectApiKey) }, "Events") },
            { key: "funnel", label: React.createElement(react_router_dom_1.Link, { to: AppRouting_1.AppPathGenerator.Project.funnel(projectApiKey) }, "Funnel") },
        ]);
    }, [projectApiKey]);
    return React.createElement(antd_1.Menu, { items: items });
};
const ToolbarGoToComponent = () => {
    const currentProjectContext = (0, CurrentProjectProvider_1.useCurrentProjectContext)();
    const projectExists = !lodash_1.default.isNil(currentProjectContext);
    if (!projectExists) {
        return null;
    }
    return React.createElement(antd_1.Dropdown, { overlay: goToMenu(currentProjectContext.projectApiKey), trigger: ["click"] },
        React.createElement(antd_1.Button, { disabled: true, type: "link", className: "goToMenu" },
            "Go To... ",
            React.createElement(icons_1.DownOutlined, null)));
};
exports.ToolbarGoToComponent = ToolbarGoToComponent;
